<template>
  <div>
    <div class="add main-block">
      <div class="add__box main-block__head">
        <h1 class="add__box-title main-block__title">Информация отправителя</h1>
        <button type="submit" class="main-block__btn default-btn">Сохранить</button>
      </div>
      <ul class="add__items">
        <li class="add__item flex">
          <p class="add__key">ФИО *</p>
          <input type="text" class="add__value" placeholder="ФИО" @focusout="onChange('fio', fio)" v-model="fio"  required />
        </li>
        <li class="add__item flex">
          <p class="add__key">Контакты *</p>
          <input v-mask="'+7##########'" @focusout="onChange('phone', phone)" v-model="phone" class="add__value" placeholder="+7" required />
        </li>
        <li class="add__item flex">
          <p class="add__key">Дата *</p>
          <input class="add__value"
                 @click="context = ' '"
                 :placeholder="date"
                 readonly="readonly"
          />
          <b-calendar
              v-model="date"
              class="add__calendar"
              @context="onContext"
              v-if="context"
              @input="context = null, onChange('date', date)"
          />
        </li>
        <li class="add__item flex">
          <p class="add__key">Время *</p>
          <input v-mask="'##:##'" @focusout="onChange('time', time)" v-model="time" placeholder="##:##" class="add__value" required />
        </li>
        <li class="add__item flex">
          <p class="add__key">Город *</p>
          <b-form-select
              v-model="from"
              class="add__value"
              :options="listCities"
              text-field="name"
              value-field="name"
              @change="onChange('from', from)"
          />
        </li>
        <li class="add__item flex">
          <p class="add__key">Тип *</p>
          <b-form-select
              v-model="type"
              class="add__value"
              :options="types"
              text-field="text"
              value-field="value"
              @change="onChange('type', type)"
          />
        </li>
        <li class="add__item flex">
          <p class="add__key">Адрес *</p>
          <input @focusout="onChange('from_address', from_address)" v-model="from_address" placeholder="Адрес" class="add__value" required @input="searchAddress()"/>
          <ul v-if="searchShow" class="city-add__search-list">
            <li
                v-for="(item, index) in searchList"
                :key="index"
                class="city-add__search-item"
                @click="
                (searchItemClick = item.GeoObject.Point.pos.split(' ')),
                  (searchShow = false)
              "
            >
              {{ item.GeoObject.name }}, {{ item.GeoObject.description }}
            </li>
          </ul>
        </li>
        <MapBlock
            class="city-add__map"
            :search-click="searchItemClick"
            :get-coords="[from_lat, from_long]"
            @coords="coords = $event"
            @address="from_address = $event"
            :cityDeliveryZones="cityDeliveryZones"
        />
        <!-- <li class="add__item flex">
          <p class="add__key">Услуги грузчика при загрузке *</p>
          <b-form-select v-model="selected" class="add__value" :options="options2" />
        </li>
        <li class="add__item flex">
          <p class="add__key">Комментарий при заборе</p>
          <input type="text" class="add__value add__value_aligin" placeholder="Хорошо" />
        </li> -->
      </ul>
    </div>
    <!-- <AddressComp class="add main-block mt-4" /> -->
    <div v-if="context" class="main-close" @click="context = null" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    // AddressComp: () => ({
    //   component: import("../addressComp"),
    // }),
    MapBlock: () => ({
      component: import("@/components/map/map-city.vue"),
    }),
  },
  data() {
    return {
      selected: null,
      collection: null,
      context: null,
      options: [
        { value: null, text: "Выберите" },
        { value: "a", text: "Выберите2" },
      ],
      options2: [
        { value: null, text: "Да" },
        { value: "a", text: "Нет" },
      ],
      phone: '+7',
      fio: '',
      date: null,
      time: null,
      from: 'Город',
      from_address: null,
      from_long: 72.02503998567278,
      from_lat: 49.94813377060378,
      searchItemClick: null,
      coords: null,
      cityDeliveryZones: [],
      searchShow: false,
      searchList: null,
      types: [
        { value: 'there', text: "Туда" },
        { value: "from_there", text: "Обратка" },
      ],
      type: 'there',
    };
  },
  methods: {
    onContext(ctx) {
      this.context = ctx
    },
    async onChange(key, param) {
      this.$emit("onInputHandler", {
        key,
        param,
      });
    },
    async searchAddress() {
      if (this.from_address) {
        await axios
            .get(
                `https://geocode-maps.yandex.ru/1.x/?apikey=c2ed0336-3aa7-4167-9030-608c1ecbf17c&format=json&geocode=${this.from_address}&lang=ru_RU`
            )
            .then((response) => {
              this.searchList = response.data.response.GeoObjectCollection.featureMember;
            });
        if (this.searchList.length > 0) {
          this.searchShow = true;
        } else {
          this.searchShow = false;
        }
      }
    },
  },
  computed: {
    ...mapState(["citiesProducts"]),
    listCities() {
      if (this.citiesProducts) {
        return [{ id: null, name: "Город" }, ...this.citiesProducts];
      }
      return [{ id: null, name: "Город" }];
    },
  },
  async created() {
    await this.$store.dispatch("getCitiesProducts");
  },
  watch: {
    coords(){
      this.from_lat = this.coords[0];
      this.from_long = this.coords[1];
      this.onChange('from_lat', this.from_lat);
      this.onChange('from_long', this.from_long);
    }
  }
};
</script>

<style scoped>
.add {
  min-height: auto;
  padding-bottom: 30px;
}

.add__items {
  font-size: 12px;
  line-height: 14px;
  color: #707070;
  padding: 3.5px 0 0 0;
}

.add__item {
  padding-top: 11.5px;
  height: 27.5px;
  position: relative;
}

.add__item:not(:last-child) {
  padding-bottom: 11.5px;
  height: 39px;
}

.main__select-icon {
  right: 8px;
  top: 53%;
  width: 7px;
}

.add__key {
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  color: #000000;
}

.add__value {
  width: 48%;
  padding-bottom: 3px;
  padding-left: 3px;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #acacac;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
  padding-right: 10px;
}
.city-add__map {
  margin-top: 24px;
  height: 300px;
  width: 100%;
}
.city-add__search-list {
  width: 50%;
  max-height: 250px;
  padding: 10px;
  border-radius: 0px 0px 20px 20px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0px -2px 20px rgba(16, 51, 115, 0.08);
  position: absolute;
  top: 30px;
  right: 0;
  z-index: 2;
}
.city-add__search-item {
  padding: 10px 5px;
  color: #000;
  border-radius: 2px;
  cursor: pointer;
}
.city-add__search-item:not(:last-child) {
  border-bottom: 1px solid #b4b4b4;
}
.city-add__search-item:hover {
  background-color: rgba(203, 206, 225, 0.71);
}
</style>
